export function PepApiErrorBanner({
  error,
  onRetry,
}: {
  error: string | null;
  onRetry?: () => void;
}) {
  if (!error) return null;

  return (
    <div className="alert alert-warning border-0 shadow-sm mb-4" role="alert">
      <strong className="d-block mb-1">Catalogue temporairement indisponible</strong>
      <p className="small mb-2">
        Nous n&apos;avons pas pu charger les données. Réessayez dans un instant ou contactez ITaaS RDC.
      </p>
      {onRetry ? (
        <button type="button" className="btn btn-sm btn-outline-dark" onClick={onRetry}>
          Réessayer
        </button>
      ) : null}
    </div>
  );
}
